import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Formik, Form, Field } from 'formik';
import TitleMain from "../Title/TitleMain";
import styles from './LoginForm.module.css';
import FieldCustom from "../Field/FieldCustom";
import FieldPassword from "../Field/FieldPassword";
import Routing from "../../services/routing";
import ReCAPTCHA from "react-google-recaptcha";

function LoginForm({ handleSubmit, email = null }) {
    const [captchaLoaded, setCaptchaLoaded] = useState(false);
    const [captchaValue, setCaptchaValue] = useState('');
    const recaptchaRef = useRef(null);

    const onCaptchaChange = (value) => {
        setCaptchaValue(value);
    };

    const onSubmit = async (values, { setSubmitting, setFieldError }) => {
        if (!captchaValue) {
            setFieldError('captcha', 'Veuillez vérifier que vous n\'êtes pas un robot');
            setSubmitting(false);
            return;
        }

        const response = await handleSubmit({ ...values, captchaToken: captchaValue }, setFieldError);

        if (response.success) {
        } else {
            if (response.key && response.message) {
                setFieldError(response.key, response.message);
            }
        }
        setSubmitting(false);
    };

    const handleCaptchaLoaded = () => {
        setCaptchaLoaded(true);
    };

    const renderCaptcha = () => {
        const captchaKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
        if (!captchaKey) {
            console.error("Captcha key is missing");
            return null;
        }

        return (
            <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={captchaKey}
                size="invisible"
                onChange={onCaptchaChange}
                asyncScriptOnLoad={handleCaptchaLoaded}
            />
        );
    };

    useEffect(() => {
        if (captchaLoaded && recaptchaRef.current) {
            recaptchaRef.current.execute();
        }
    }, [captchaLoaded]);

    return (
        <Formik
            initialValues={{ email: email ?? '', password: '', captchaToken: '' }}
            onSubmit={onSubmit}
        >
            {({ isSubmitting, setFieldError }) => (
                <Form className={styles.form}>
                    <div>
                        <TitleMain text="CONNEXION" />

                        <FieldCustom label={"Identifiant"} type={"email"} name={"email"} placeholder={"Entrez votre email"} />

                        <FieldPassword />

                        <div>
                            <Link to={Routing.routes.passwordReset} className={styles.link}>
                                Mot de passe oublié ?
                            </Link>
                        </div>
                    </div>

                    <button type="submit" className={`${styles.btn} btn`} disabled={isSubmitting}>
                        CONTINUER
                    </button>

                    {renderCaptcha()}
                </Form>
            )}
        </Formik>
    );
}

export default LoginForm;
